import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { HomeHeaderComponent } from './components/home-header/home-header.component';
import { HomeFooterComponent } from './components/home-footer/home-footer.component';
import { SimpleLayoutComponent } from '../containers/simple-layout/simple-layout.component';

import { HomeCardConfigComponent } from './home-card-config/home-card-config.component';
import { HomeCardConfigHeaderComponent } from './home-card-config-header/home-card-config-header.component';
import { HomeCardConfigLeftComponent } from './home-card-config-left/home-card-config-left.component';
import { HomeCardConfigRightComponent } from './home-card-config-right/home-card-config-right.component';
import { TemplateEditorComponent } from './template-editor/template-editor.component';

import { EditorModule } from '@tinymce/tinymce-angular';
import { RecaptchaModule } from 'ng-recaptcha';
import { PaginationComponent } from './../shared/components/pagination/pagination.component';
import { MasterAutoComponent } from './autocomplete/master-auto/master-auto.component';
import { EntitySelectionComponent } from './entity-selection/entity-selection.component';
import { DatefieldComponent } from './components/datefield/datefield.component';
import { RequiredComponent } from './components/required/required.component';
import { QdatePipe } from './pipes/qdate/qdate.pipe';
import { SafeurlPipe } from './pipes/safeurl/safeurl.pipe';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FullLayoutComponent } from '../containers/full-layout/full-layout.component';
import { MainMenuComponent } from '../manager/main-menu/main-menu.component';
import { MainBodyComponent } from '../manager/main-body/main-body.component';
import { MenuHeaderComponent } from '../manager/menu-header/menu-header.component';
import { MenuFooterComponent } from '../manager/menu-footer/menu-footer.component';
import { MenuNavComponent } from '../manager/menu-nav/menu-nav.component';
import { TabsComponent } from '../shared/tabs/tabs.component';
import { AppHeaderLogoComponent } from '../manager/app-header-logo/app-header-logo.component';
import { AlertComponent } from '../shared/alert/alert.component';
import { QdatetimePipe } from './pipes/qdatetime/qdatetime.pipe';
import { TestCentersComponent } from './autocomplete/test-centers/test-centers.component';
import { SearchComponent } from './search/search.component';
import { QdatefullPipe } from './pipes/qdatefull.pipe';
import { FormatTimePipe } from './pipes/timer.pipe';
import { UploaderComponent } from './uploader/uploader.component';


@NgModule({
  declarations: [HomeHeaderComponent, AlertComponent,
    SimpleLayoutComponent,
    HomeFooterComponent,
    HomeCardConfigComponent,
    HomeCardConfigHeaderComponent,
    HomeCardConfigLeftComponent,
    HomeCardConfigRightComponent,
    TemplateEditorComponent,
    UploaderComponent,
    PaginationComponent,
    MasterAutoComponent,
    EntitySelectionComponent,
    DatefieldComponent,
    RequiredComponent,
    QdatePipe,
    SafeurlPipe,
    FullLayoutComponent,
    MainMenuComponent,
    MainBodyComponent,
    MenuHeaderComponent,
    MenuFooterComponent,
    MenuNavComponent,
    TabsComponent,
    AppHeaderLogoComponent,
    QdatetimePipe,
    TestCentersComponent,
    SearchComponent,
    QdatefullPipe,
    FormatTimePipe
  ],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    RouterModule,
    EditorModule,
    RecaptchaModule,
    BsDatepickerModule.forRoot()

  ],
  exports: [
    HomeHeaderComponent,
    HomeFooterComponent,
    SimpleLayoutComponent,
    HomeCardConfigComponent,
    UploaderComponent,
    HomeCardConfigLeftComponent,
    HomeCardConfigRightComponent,
    PaginationComponent,
    MasterAutoComponent,
    EntitySelectionComponent,
    DatefieldComponent,
    RequiredComponent,
    QdatePipe,
    SafeurlPipe,
    FullLayoutComponent,
    MainMenuComponent,
    MainBodyComponent,
    MenuHeaderComponent,
    MenuFooterComponent,
    MenuNavComponent,
    TabsComponent,
    AppHeaderLogoComponent,
    AlertComponent,
    QdatetimePipe,
    TemplateEditorComponent,
    TestCentersComponent,
    SearchComponent,
    QdatefullPipe,
    FormatTimePipe
  ]
})
export class SharedModule { }
